import Model from './Model'

export default class Accident extends Model
{
    static async allWithActivity (filters) {
        const params = { has_activity: true, from: filters.from, to: filters.to }
        const { data } = await Http.get(route('api.v1.accidents.index'), { params })
        return this.make(data)
    }
}
